import { BalanceType } from 'utils/enums';

type SelectOption<Value extends string | number = number> = {
  label: string;
  value: Value;
};

export const balanceTypesOptions: SelectOption<BalanceType>[] = [
  { label: 'Kaikki', value: BalanceType.All },
  { label: 'Ennakot', value: BalanceType.Prepayments },
  { label: 'Saatavat', value: BalanceType.Receivables },
];
